import { lazy } from 'react';

/** Загружает карточку тиража промокодов */
export const PromoCodePrintingDetailsPageAsync = lazy(() => import('./PromoCodePrintingDetailsPage'));
